export default __webpack_public_path__ + "static/video2-58af249b79df113f5289dd5f90b0e7f1.mp4";